interface ILanguages {
  languages: string[];
  default: string;
}

export const getLanguages = (): ILanguages => {
  try {
    return JSON.parse(import.meta.env.VITE_LANGUAGE_SETTINGS);
  } catch (e) {
    return {
      default: "en",
      languages: [],
    };
  }
};

export type SettingsItem = {
  id: string;
  title: string;
  icon: string;
};

export const SETTINGS_ITEM_MAP: Record<string, SettingsItem> = {
  profile: {
    id: "profile",
    title: "settings_User Profile",
    icon: "icon-linear-profile-circle",
  },
  languages: {
    id: "languages",
    title: "settings_Languages",
    icon: "icon-linear-global",
  },
  notifications: {
    id: "notifications",
    title: "settings_Notifications",
    icon: "icon-linear-notification",
  },
  subscriptions: {
    id: "subscriptions",
    title: "settings_Subscription",
    icon: "icon-money-change",
  },
  friends: {
    id: "friends",
    title: "common_Friends",
    icon: "icon-linear-profile-2user",
  },
  shop: {
    id: "shop",
    title: "shop_Shop",
    icon: "icon-shopping-bag1",
  },
  level: {
    id: "level",
    title: "settings_My Level & Gems",
    icon: "icon-medal",
  },
  faq: {
    id: "faq",
    title: "settings_FAQ",
    icon: "icon-message-question",
  },
  help: {
    id: "help",
    title: "settings_Help",
    icon: "icon-headphone",
  },
  privacy: {
    id: "privacy",
    title: "settings_Privacy policy",
    icon: "icon-shield-security",
  },
  tnc: {
    id: "tnc",
    title: "settings_Terms and conditions",
    icon: "icon-document",
  },
  cookie: {
    id: "cookie",
    title: "settings_Cookie Policy",
    icon: "icon-monitor",
  },
};
